import { MemberListWithFallback as View } from 'ui-components'
import { useIsWorkspaceOwner } from '~workspace/hooks/useIsWorkspaceOwner'
import { useDeleteInvitedUser } from '~workspace/queries/useDeleteInvitedUser'
import { useDeleteWorkspaceMember } from '~workspace/queries/useDeleteWorkspaceMember'
import {
  useGetCurrentWorkspaceInvitedUsers,
  useGetCurrentWorkspaceMembers
} from '~workspace/queries/useGetWorkspaceById'

const MemberList = () => {
  const isWorkspaceOwner = useIsWorkspaceOwner()
  const members = useGetCurrentWorkspaceMembers()
  const invitedUsers = useGetCurrentWorkspaceInvitedUsers()
  const deleteWorkspaceMember = useDeleteWorkspaceMember()
  const deleteInvitedUser = useDeleteInvitedUser()

  const memberInvitedUsers = invitedUsers?.filter(
    (invitedUser) => invitedUser.role === 'member'
  )

  const handleDeleteInvitedUserConfirm = async (_, invitedUser) => {
    await deleteInvitedUser.mutateAsync({
      userId: invitedUser.userId,
      workspaceId: invitedUser.workspaceId
    })
  }

  const handleDeleteMemberConfirm = async (_, member) => {
    await deleteWorkspaceMember.mutateAsync({ id: member.id })
  }

  return (
    <View
      members={members}
      invitedUsers={memberInvitedUsers}
      canInviteMember={isWorkspaceOwner}
      canDeleteMember={isWorkspaceOwner}
      isDeletingMember={deleteWorkspaceMember.isPending}
      onDeleteInvitedUserConfirm={handleDeleteInvitedUserConfirm}
      onDeleteMemberConfirm={handleDeleteMemberConfirm}
    />
  )
}

export { MemberList }
